import http from '@/utils/http' //引入axios
export const getModule = data => http.get('/maintenance-center/api/module', {
    params: data
})
export const addModule = data => http.post('/maintenance-center/api/module', data)
export const deleteModule = data => http.delete('/maintenance-center/api/module', {
    params: data
})
export const editModule = data => http.put('/maintenance-center/api/module', data)
export const getModuleLanguage = data => http.get('/maintenance-center/api/module/getEnable', {
    params: data
})
export const getOption = data => http.get('/maintenance-center/api/option', {
    params: data
})
export const addOption = data => http.post('/maintenance-center/api/option', data)
export const editOption = data => http.put('/maintenance-center/api/option', data)
export const deleteOption = data => http.delete('/maintenance-center/api/option', {
    params: data
})
export const getByModuleId = data => http.get('/maintenance-center/api/option/findByModuleId', {
    params: data
})
export default {
    getModule,
    addModule,
    deleteModule,
    editModule,
    getModuleLanguage,
    getOption,
    addOption,
    editOption,
    deleteOption,
    getByModuleId
}